let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("kMiW6")).then(() => parcelRequire('1xexx'));